import React from 'react'
import Banner from "./shared/banner"
import Card from "./shared/card"
import SimilarItem from "./shared/similarItem"

const SpecificProduct = () => {
  return (
      <main>
      <Banner />
      <Card />
      <SimilarItem/>
    </main>
  )
}

export default SpecificProduct